(function (angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.common.name)
        .factory(schoolwork12.app.common.services.utilService, ['$rootScope',
            function ($rootScope) {
           
            // Custom Sorting for dates
            var sortDateFn = function (a, b) {
                var nulls = handleNulls(a, b);
                if ( nulls !== null ) {
                    return nulls;
                }
                else {               
                    var aDate =  moment(a, "MMM/DD/YYYY");
                    var bDate =  moment(b, "MMM/DD/YYYY");
                    if (aDate > bDate) {
                        return 1;
                    } 
                    else if (bDate > aDate) {
                        return -1;
                    } 
                    else {
                        return 0;   
                    }
                 }
            };
            
            // Sorts nulls and undefined to the bottom (top when descending).  
            // @returns null if there were no nulls/undefined, otherwise returns
            // a sort value that should be passed back from the sort function
            var handleNulls = function(a, b) {
                // We want to allow zero values and false values to be evaluated in the sort function
                if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                    // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                    if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                        return 0;
                    }
                    else if (!a && a !== 0 && a !== false) {
                        return 1;
                    }
                    else if (!b && b !== 0 && b !== false) {
                        return -1;
                    }
                }
                return null;
            };    

            var schoolSubjectMap = function(schoolSubjectList){
                var subjectMap = {};
                angular.forEach(schoolSubjectList, function(subject){
                    if(angular.isDefined(subject.schoolSubjectId)){
                    	subjectMap["schSubjectId"+subject.schoolSubjectId] = subject;
                    }
                    if(angular.isDefined(subject.k12SubjectId)){
                    	subjectMap["k12SubjectId"+subject.k12SubjectId] = subject;
                    }
                });
                return subjectMap;
            }
            
            var schoolCourseMap = function(schoolSubjectList){
                var courseMap = {};
                angular.forEach(schoolSubjectList, function(subject){
                    var k12Id = "";
                    var schId = "";
                    if(angular.isDefined(subject.schoolSubjectId)){
                        k12Id = "schSubjectId"+subject.schoolSubjectId;
                    }
                    if(angular.isDefined(subject.k12SubjectId)){
                    	schId = "k12SubjectId"+subject.k12SubjectId;
                    }
                    if(angular.isDefined(subject.courses)){
                        angular.forEach(subject.courses, function(course){
                            if(k12Id!="")
                                courseMap[k12Id + "courseId" + course.id] = course;
                            if(schId!="")
                                courseMap[schId + "courseId" + course.id] = course;
                        });
                    }
                });
                return courseMap;
            }

            return {
                sortDateFn: sortDateFn,
                schoolSubjectMap: schoolSubjectMap,
                schoolCourseMap: schoolCourseMap
            };
        }
    ]);
}(angular, schoolwork12));
